/** Limiar de desconexão: 3,5× o intervalo do heartbeat (10 s). */
export const DESCONEXAO_LIMITE_MS = 35_000;

/**
 * Fonte de verdade para o status de presença de uma tela.
 * Usa `ultima_conexao` em vez do campo `status` do banco, que pode
 * permanecer 'online' por até 60 s após uma desconexão abrupta (ghost session).
 */
export function isTelaOnline(
  ultimaConexao: string | null | undefined,
  agoraMs: number = Date.now(),
): boolean {
  if (!ultimaConexao) return false;
  return (agoraMs - new Date(ultimaConexao).getTime()) < DESCONEXAO_LIMITE_MS;
}

/** Broadcast recente no canal `canal_tela_{telaId}` prova presença imediata do Player. */
export function isBroadcastRecente(
  ultimaAtividadePlayerMs: number | null | undefined,
  agoraMs: number = Date.now(),
): boolean {
  return ultimaAtividadePlayerMs != null
    && (agoraMs - ultimaAtividadePlayerMs) < DESCONEXAO_LIMITE_MS;
}

/** Presença no Jukebox mobile: heartbeat (`ultima_conexao`) OU broadcast recente. */
export function isPlayerPresente(
  ultimaConexao: string | null | undefined,
  ultimaAtividadePlayerMs: number | null | undefined,
  agoraMs: number = Date.now(),
): boolean {
  return isTelaOnline(ultimaConexao, agoraMs)
    || isBroadcastRecente(ultimaAtividadePlayerMs, agoraMs);
}
